import {useSelector} from "react-redux";
import {StateModel} from "../Models/StateModel";
import {EventModel} from "../Models/EventModel";
import axios from "axios";
import {AcceptedCardResponseModel} from "../Models/AcceptedCardResponseModel";

export const useCardTypeAccepted = (): (brand: string | undefined) => Promise<AcceptedCardResponseModel> => {
    const event = useSelector<StateModel, EventModel | undefined>(state => state.event)

    return async (brand: string | undefined): Promise<AcceptedCardResponseModel> => {
        if (!event) {
            const response: AcceptedCardResponseModel = {
                isAccepted: true,
                message: ""
            }
            return Promise.resolve(response)
        }

        const result = await axios.get(`${process.env.REACT_APP_BART_URL}/accepted-card/check?eventId=${event.id}&cardBrand=${brand}`,)
        if (result) {
            return result.data
        }
        return Promise.reject()
    }
}
